import { FC } from 'react'
import { Text, useDateFormat } from 'react-common'
import { useTranslation } from 'react-i18next'
import { SvgComponent, Tooltip2 } from '@platform/ui'
import cn from 'classnames'
import styles from './ExpireDate.module.scss'

type ExpireDateProps = {
  expirationDate: string
}

export const ExpireDate: FC<ExpireDateProps> = ({ expirationDate }) => {
  const { formatDateShort } = useDateFormat()
  const { t } = useTranslation()

  if (!expirationDate) {
    return null
  }

  const timeDiff = new Date(expirationDate).getTime() - new Date().getTime()
  const isExpired = timeDiff <= 0

  return (
    <Text.Body
      className={cn({
        [styles.expiredDate]: true,
        [styles.expired]: isExpired,
      })}
    >
      {t('courseDetails.certificates.expiryDate', { date: formatDateShort(expirationDate) })}

      {isExpired && (
        <Tooltip2 content={t('courseDetails.certificates.hasExpired')} position="top">
          <div className={styles.iconWrapper}>
            <SvgComponent name="InformationInCircleBold" />
          </div>
        </Tooltip2>
      )}
    </Text.Body>
  )
}
